export default __webpack_public_path__ + "a4d4624345969ac429a85a1c5c0bd7e1.png";